import { InternalMessageResponse } from "features/CenterContent/RoleContent/InternalMessage/schema/responseSchema";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";

export type InternalMessage = Pick<
  InternalMessageResponse,
  "uuid" | "updatedAt" | "customTexts"
>;

export type PlanInternalMessage = {
  messages: { NOB?: { message: string } };
  createdAt: string;
  updatedAt: string;
};

export type PlanEventInformation = {
  information: CombinedHistoryResponse;
  internalMessages: PlanInternalMessage[];
};

export type PlanMeasures = {
  noCoverage: PlanEventInformation[];
  unpublished: PlanEventInformation[];
  published: PlanEventInformation[];
  withdrawn: PlanEventInformation[];
};

export type PlanMeasureKey = keyof PlanMeasures;
export const PLAN_MEASURE_KEYS: PlanMeasureKey[] = [
  "noCoverage",
  "unpublished",
  "published",
  "withdrawn",
];
